import { __decorate } from "tslib";
import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { BehaviorSubject } from "rxjs";
import { map } from "rxjs/operators";
import { SuspendedEnum } from "../../organisation-users/organisation-users.constants";
import { ApiModuleConstants } from "../../../../shared/constants/api-constants/api-module.constants";
let OrganisationModuleService = class OrganisationModuleService {
    http;
    organisationModulesUrl = ApiModuleConstants.URL;
    organisationModulesSubject = new BehaviorSubject([]);
    $organisationModulesSubject = this.organisationModulesSubject.asObservable();
    pdfImage = new BehaviorSubject(null);
    pdfImageAsObservable = this.pdfImage.asObservable();
    constructor(http) {
        this.http = http;
    }
    setPDFImage(pdfImage) {
        this.pdfImage.next(pdfImage);
    }
    getOrganisationModules(organisationId) {
        const params = {
            $filter: `organisationId eq ${organisationId}`,
            $expand: "moduleSettings($filter = key eq 'InvoiceTemplate' ), pdfImageStamp"
        };
        return this.http.get(this.organisationModulesUrl, { params }).pipe(map(organisationModules => {
            this.organisationModulesSubject.next(organisationModules.value);
            const modules = organisationModules.value.map(organisationModule => {
                return {
                    ...organisationModule,
                    suspended: organisationModule.suspended === true ? SuspendedEnum.Yes : SuspendedEnum.No,
                    enableAFLAPortal: organisationModule.enableAFLAPortal === true ? SuspendedEnum.Yes : SuspendedEnum.No
                };
            }).sort((a, b) => 0 - (a.name.toLowerCase().trim() > b.name.toLowerCase().trim() ? -1 : 1));
            return [...modules];
        }));
    }
    getModule(moduleId) {
        return this.http.get(`${this.organisationModulesUrl}/${moduleId}`);
    }
    suspendOrReinstateModule(moduleId, action) {
        return this.http.patch(`${this.organisationModulesUrl}/${moduleId}`, {
            suspended: action
        });
    }
    createOrganisationModule(organisationModule) {
        return this.http.post(this.organisationModulesUrl, organisationModule);
    }
    updateOrganisationModule(organisationModule) {
        return this.http.patch(`${this.organisationModulesUrl}/${organisationModule.id}`, {
            workflowJobId: organisationModule.workflowJobId,
            workflowItemName: organisationModule.workflowItemName,
            workflowName: organisationModule.workflowName,
            name: organisationModule.name,
            metadata: "",
            moduleTemplateId: organisationModule.moduleTemplateId,
            enableResubmission: organisationModule.enableResubmission,
            referenceTemplate: organisationModule.referenceTemplate,
            resubmissionReferenceTemplate: organisationModule.resubmissionReferenceTemplate,
            resubmissionPeriod: organisationModule.resubmissionPeriod,
            resubmissionPeriodUnit: organisationModule.resubmissionPeriodUnit,
            enableAflaPortal: organisationModule.enableAFLAPortal,
            simulationMode: organisationModule.simulationMode,
            notificationAutoSendStatusUpdates: organisationModule.notificationAutoSendStatusUpdates,
            notificationEnableApplicantConfirmations: organisationModule.notificationEnableApplicantConfirmations
        });
    }
    UploadReportTemplate(document, key) {
        return this.http.post(`${this.organisationModulesUrl}/${key}/${ApiModuleConstants.UPLOAD_INVOICE_TEMPLATE}`, document)
            .pipe(map(res => {
            return res;
        }));
    }
    getDownloadTemplate(moduleId) {
        return this.http.get(`${ApiModuleConstants.URL}/${moduleId}/${ApiModuleConstants.FUNCTION_DOWNLOAD_INVOICE_TEMPLATE}`, { responseType: "blob" });
    }
    uploadModuleHelpFile(moduleId, formData) {
        ;
        return this.http.post(`${ApiModuleConstants.URL}/${moduleId}/${ApiModuleConstants.FUNCTION_UPLOAD_HELP_FILE}`, formData);
    }
    downloadPdfStamp(moduleId) {
        return this.http.get(`${ApiModuleConstants.URL}/${moduleId}/${ApiModuleConstants.FUNCTION_DOWNLOAD_MODULE_STAMP}`, { responseType: "blob" });
    }
    updatePdfStampImage(moduleId, formData) {
        return this.http.post(`${this.organisationModulesUrl}/${moduleId}/AddModuleSignature`, formData);
    }
    postPdfStampImage(moduleId, formData) {
        return this.http.post(`${this.organisationModulesUrl}/${moduleId}/AddModuleSignature`, formData);
    }
    getHelpFileInformation(moduleId) {
        return this.http.get(`${ApiModuleConstants.URL}/${moduleId}/${ApiModuleConstants.FUNCTION_GET_HELP_FILE_INFORMATION}`);
    }
    static ctorParameters = () => [
        { type: HttpClient }
    ];
};
OrganisationModuleService = __decorate([
    Injectable({
        providedIn: "root"
    })
], OrganisationModuleService);
export { OrganisationModuleService };
